import Dayjs from 'dayjs'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { ptBR } from './locales'
import 'dayjs/locale/pt-br'

const resources = {
  'pt-br': {
    translation: ptBR,
  },
}

export const languageChanged = locale => {
  if (locale === 'pt-br') Dayjs.locale('pt-br')
}

i18n
  .use(initReactI18next)
  .on('languageChanged', languageChanged)
  .init({
    DateTimeParser: Dayjs,
    debug: process.env.NODE_ENV === 'development',
    fallbackLng: 'pt-br',
    lowerCaseLng: true,
    load: 'currentOnly',
    resources,
    returnNull: false,
    interpolation: {
      escapeValue: false,
      format: (value, format) => (value instanceof Date ? Dayjs(value).format(format) : value),
    },
    react: {
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
      transSupportBasicHtmlNodes: true,
    },
  })

export default i18n
